var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "mr-8" },
    [
      _c(
        "DefaultContentLayout",
        [
          _c(
            "LoadingOverlay",
            {
              attrs: {
                hasData: _vm.hasData,
                loading: _vm.loading,
                spinnerCentered: "",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-row justify-between h-12 items-center",
                },
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "font-semibold w-max-content custom-title mt-4",
                    },
                    [_vm._v(" Managers ")]
                  ),
                  _vm.getRoleAdmin
                    ? _c(
                        "div",
                        [
                          _c("UiButton", {
                            staticClass: "ml-4",
                            attrs: {
                              buttonText: "Invite",
                              variant: "black",
                              size: "lg2",
                              buttonClasses: "customHeight40",
                            },
                            on: { click: _vm.handleInviteClick },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "icon",
                                  fn: function () {
                                    return [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "18",
                                            height: "18",
                                            viewBox: "0 0 16 16",
                                            fill: "none",
                                          },
                                        },
                                        [
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                "clip-path":
                                                  "url(#clip0_2964_15353)",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d: "M9.23077 1.23077C9.23077 0.55 8.68077 0 8 0C7.31923 0 6.76923 0.55 6.76923 1.23077V6.76923H1.23077C0.55 6.76923 0 7.31923 0 8C0 8.68077 0.55 9.23077 1.23077 9.23077H6.76923V14.7692C6.76923 15.45 7.31923 16 8 16C8.68077 16 9.23077 15.45 9.23077 14.7692V9.23077H14.7692C15.45 9.23077 16 8.68077 16 8C16 7.31923 15.45 6.76923 14.7692 6.76923H9.23077V1.23077Z",
                                                  fill: "white",
                                                },
                                              }),
                                            ]
                                          ),
                                          _c("defs", [
                                            _c(
                                              "clipPath",
                                              {
                                                attrs: {
                                                  id: "clip0_2964_15353",
                                                },
                                              },
                                              [
                                                _c("rect", {
                                                  attrs: {
                                                    width: "18",
                                                    height: "18",
                                                    fill: "white",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "hover-icon",
                                  fn: function () {
                                    return [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "17",
                                            height: "16",
                                            viewBox: "0 0 17 16",
                                            fill: "none",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d: "M9.73077 1.23077C9.73077 0.55 9.18077 0 8.5 0C7.81923 0 7.26923 0.55 7.26923 1.23077V6.76923H1.73077C1.05 6.76923 0.5 7.31923 0.5 8C0.5 8.68077 1.05 9.23077 1.73077 9.23077H7.26923V14.7692C7.26923 15.45 7.81923 16 8.5 16C9.18077 16 9.73077 15.45 9.73077 14.7692V9.23077H15.2692C15.95 9.23077 16.5 8.68077 16.5 8C16.5 7.31923 15.95 6.76923 15.2692 6.76923H9.73077V1.23077Z",
                                              fill: "black",
                                              "fill-opacity": "0.88",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              3140612021
                            ),
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
              _c(
                "div",
                [
                  _c("ManagerNewSearchFilters", {
                    attrs: {
                      filters: _vm.managerFilters,
                      getRoleAdmin: _vm.getRoleAdmin,
                    },
                    on: {
                      filtersChanged: _vm.updateFilters,
                      filtersReset: _vm.resetFilters,
                    },
                  }),
                ],
                1
              ),
              _c("ActionPanel", {
                staticClass: "mb-6",
                attrs: {
                  total: !_vm.getRoleAdmin
                    ? this.maangerCount
                    : this.adminCount,
                  pageName: `Total Managers`,
                },
              }),
              _vm.managersEmpty
                ? [
                    _c("EmptyListPlaceholder", {
                      attrs: { title: _vm.emptyListPlaceholder },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "image",
                            fn: function () {
                              return [_c("EmptyListImageManagers")]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2783177247
                      ),
                    }),
                  ]
                : _vm._e(),
              !_vm.getRoleAdmin
                ? _c(
                    "div",
                    { staticClass: "flex flex-wrap gap-4" },
                    _vm._l(_vm.managersFilterd, function (manager) {
                      return _c("ManagerListCard", {
                        key: manager.id,
                        attrs: {
                          manager: manager,
                          currentUser: _vm.currentUser,
                          activeManagersCount: _vm.activeManagersCount,
                          accessAllowedManagersCount:
                            _vm.accessAllowedManagersCount,
                          getRoleAdmin: _vm.getRoleAdmin,
                        },
                        on: {
                          message: _vm.message,
                          activate: _vm.activateManager,
                        },
                      })
                    }),
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "flex flex-wrap gap-4" },
                    _vm._l(_vm.managers, function (manager) {
                      return _c("ManagerListCard", {
                        key: manager.id,
                        attrs: {
                          manager: manager,
                          currentUser: _vm.currentUser,
                          activeManagersCount: _vm.activeManagersCount,
                          accessAllowedManagersCount:
                            _vm.accessAllowedManagersCount,
                          getRoleAdmin: _vm.getRoleAdmin,
                        },
                        on: {
                          message: _vm.message,
                          activate: _vm.activateManager,
                        },
                      })
                    }),
                    1
                  ),
              _c("CardPagination", {
                attrs: { config: _vm.paginationConfig },
                on: {
                  "update:config": function ($event) {
                    _vm.paginationConfig = $event
                  },
                },
              }),
            ],
            2
          ),
        ],
        1
      ),
      _vm.inviteDialog
        ? _c("ManagerInviteNew", {
            attrs: {
              companyId: _vm.company ? _vm.company.id : null,
              currentUser: _vm.currentUser,
              companyBusinessName: _vm.company.business_name,
              managersUnlimited: true,
              users: _vm.users,
              activeManagersCount: _vm.activeManagersCount,
              accessAllowedManagersCount: _vm.accessAllowedManagersCount,
            },
            on: {
              alert: (e) => _vm.$emit("alert", e),
              refresh: _vm.refresh,
              handleDeleteRow: _vm.handleDeleteRow,
              clearUsers: _vm.clearUsers,
              add: _vm.add,
              openManagerAddonModal: function ($event) {
                _vm.showAddAddtionalManagerDialog = true
              },
            },
            model: {
              value: _vm.inviteDialog,
              callback: function ($$v) {
                _vm.inviteDialog = $$v
              },
              expression: "inviteDialog",
            },
          })
        : _vm._e(),
      _vm.showSubscriptionDialog
        ? _c("AddSubscription", {
            attrs: {
              company: _vm.company,
              currentUser: _vm.currentUser,
              isLoading: _vm.managerStatusProcessing,
            },
            on: {
              close: function ($event) {
                _vm.showSubscriptionDialog = false
              },
              addAdditionalManager: function ($event) {
                _vm.showSubscriptionDialog = false
                _vm.inviteDialog = true
              },
            },
          })
        : _vm._e(),
      _vm.showExceeded
        ? _c("ExceedDialog", {
            on: {
              close: function ($event) {
                _vm.showExceeded = false
              },
            },
          })
        : _vm._e(),
      _vm.showAddAddtionalManagerDialog
        ? _c("AddAddtionalManager", {
            attrs: { company: _vm.company, currentUser: _vm.currentUser },
            on: {
              addAdditionalManager: _vm.HandleAddAdditionalManager,
              close: function ($event) {
                _vm.showAddAddtionalManagerDialog = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }